<template>
  <div>
    <v-card class="invitation">
      <v-card-title>
        {{ $t('pages.invitation.title') }}
      </v-card-title>
      <v-card-text>
        <form @submit.prevent="submit()">
          <component
            v-for="input in inputs"
            :key="input.key"
            :is="input.component"
            :config="input"
            v-model="form[input.key]">
          </component>
          <v-btn
            type="submit"
            primary light block ripple
            :loading="loading">
            {{ $t('pages.invitation.submit') }}
          </v-btn>
        </form>
      </v-card-text>
    </v-card>
    <a class="btn btn--block btn--flat btn--light" target="_blank" :href="terms">{{ $t('pages.invitation.terms') }}</a>
    <a class="btn btn--block btn--flat btn--light" target="_blank" :href="privacy">{{ $t('pages.invitation.privacy') }}</a>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { TextInput, BooleanInput } from '@/components/inputs'
  export default {
    props: {
      platformToken: {
        type: String,
        required: true
      },
      token: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        error: {},
        form: {
          password: null,
          confirmation: null,
          terms: false
        }
      }
    },
    computed: {
      ...mapGetters({
        manager: 'application/specificManager',
        loading: 'skiliko/invitations/isLoading'
      }),
      terms () { return this.manager.terms },
      privacy () { return this.manager.privacy },
      inputs () {
        return [
          { key: 'password', required: true, component: TextInput, type: 'password' },
          { key: 'confirmation', required: true, component: TextInput, type: 'password' },
          { key: 'terms', required: true, component: BooleanInput }
        ]
          .map(input => {
            const data = { terms: this.terms, privacy: this.privacy }
            return {
              ...input,
              label: this.$t(`pages.invitation.labels.${input.key}`, data),
              errors: (this.error[input.key] || []).map(e => () => e)
            }
          })
      }
    },
    methods: {
      ...mapActions({
        accept: 'skiliko/invitations/accept'
      }),
      submit () {
        this.accept({
          token: this.token,
          password: this.form.password,
          passwordConfirmation: this.form.confirmation,
          platformToken: this.platformToken
        })
          .then(_ => this.$router.replace({ path: this.$route.query.redirect || '/' }))
          .catch(({ response }) => (this.error = (response || {}).data || {}))
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .invitation {
    width: 350px;
    max-width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Invitation.vue